import React from 'react';

type ConsumerSearchContextValue = {
  lookupType: 'phoneLookup' | 'tokenLookup' | 'phoneValidation' | null;
  isAccountLookup: boolean;
  skipToPath?: string;
  i18nPrefix: string;
  hasExistingAccount: boolean;
};

const ConsumerSearchContext = React.createContext<ConsumerSearchContextValue>({
  i18nPrefix: '',
  isAccountLookup: false,
  hasExistingAccount: false,
  lookupType: null,
});

export default ConsumerSearchContext;
